import { Reveal } from "@/components/motion";

// A soft arched image band, matching the site's architectural motif.
// Used on inner pages that don't have their own photography.
export const ArchImage = ({ src, alt, maxWidth = 520, height = 460, testId }) => (
  <section className="px-6 md:px-12 pt-2 pb-12 md:pb-16" data-testid={testId}>
    <div className="mx-auto" style={{ maxWidth: `${maxWidth}px` }}>
      <Reveal>
        <div
          className="relative mx-auto overflow-hidden shadow-[0_30px_60px_rgba(41,54,80,0.15)]"
          style={{ borderTopLeftRadius: "50% 55%", borderTopRightRadius: "50% 55%" }}
        >
          <img
            src={src}
            alt={alt}
            loading="lazy"
            className="w-full object-cover"
            style={{ height: `${height}px` }}
          />
        </div>
      </Reveal>
    </div>
  </section>
);

export default ArchImage;
